module.exports = __webpack_public_path__ + "static/img/ydbg5@2x.3309078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ydbg5@2x.png
// module id = XVFc
// module chunks = 1